import { toCamelCase } from '@cli-utils/text.js'
import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'
import { renderWebhookEventsBarrelImportsTemplate } from '@next-adapter/templates/renderers/snapshots/barrels/render-webhook-events-barrel.js'

export function renderWebhookEventsBarrel(extractNames: string[], namespaceValue: string): string {
  const namespace = resolveAdminNamespace(namespaceValue)
  const importLines = extractNames.map(
    (name) => `import { ${toCamelCase(name)}WebhookEvents } from './webhook-events/${name}'`
  )
  const entryLines = extractNames.map((name) => `  ${toCamelCase(name)}WebhookEvents`)
  const extractImports = importLines.length > 0 ? `\n${importLines.join('\n')}` : ''

  const entries = entryLines.length > 0 ? `[\n${entryLines.join(',\n')}\n]` : '[]'

  return renderWebhookEventsBarrelImportsTemplate({
    namespaceAlias: String(namespace.alias),
    extractImports: String(extractImports),
    entries: String(entries)
  })
}
